module.exports = __webpack_public_path__ + "img/pie-chart.a7acf550.svg";